export const context = process.env.VUE_APP_API_CONTEXT_PATH || '';
